<div class="task-container">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }
  @if (!dataLoading()) {
    <div class="header">
      <h1 class="task-description">{{task().description}}</h1>
      <button class="task-close-button" (click)="closeTask()">
        <span>Close</span>
      </button>
      <button aria-label="Close" class="task-close-icon" (click)="closeTask()">
        <svg viewBox="-2 -1 24 24">
          <path d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z"></path>
        </svg>
      </button>
    </div>
    <div class="task-progress">
      <div class="bar" [class.completed]="task().readonly" [style.width.%]="task().percentageComplete"></div>
    </div>
    <div class="content">
      <div class="task-wizard">
        <div class="task-step-indicator">
          <ul>
            @for (step of task().steps; track step; let i = $index) {
              <li class="step"
                [class.current]="i === currentStepIndex()" [class.completed]="step.completed" [class.disabled]="i > maxEditableStepIndex()">
                <button type="button"
                  class="step-button"
                  (click)="goToStepIndex(i)"
                  [disabled]="i > maxEditableStepIndex()"
                  [attr.aria-label]="'Go to step ' + (i + 1)">
                  <svg>
                    <polygon points="10.525 0.25 12.4 2.125 4.89999998 9.625 0.399999976 5.125 2.27499998 3.25 4.89999998 5.875"></polygon>
                  </svg>
                  <span>{{i + 1}}</span>
                </button>
              </li>
            }
          </ul>
        </div>
        <div class="task-step-card">
          @if (stepLoadError()) {
            <div class="task-step-error" role="alert">
              <p>Something went wrong loading this step.</p>
              <button class="task-retry-button" (click)="retryLoadStep()">Try again</button>
            </div>
          } @else {
            <ng-template appTaskStepAnchor></ng-template>
            @if (stepProcessing()) {
              <div class="task-step-processing-overlay">
                <app-loading-animation></app-loading-animation>
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
</div>
